import { render, staticRenderFns } from "./OrderSearchFilters.vue?vue&type=template&id=a0546aba&scoped=true&"
import script from "./OrderSearchFilters.vue?vue&type=script&lang=js&"
export * from "./OrderSearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrderSearchFilters.vue?vue&type=style&index=0&id=a0546aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0546aba",
  null
  
)

/* custom blocks */
import block0 from "./OrderSearchFilters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports